module.exports = __webpack_public_path__ + "img/receipt.a35fa8c7.svg";